import { t } from '@lingui/macro';
import type { ApiClient } from '@prismo-io/schemas';
import { z } from 'zod';

const ParamsSchema = z.object({
  id: z.string().uuid(),
});

export type ParamsSchemaT = z.infer<typeof ParamsSchema>;

const ResultSchema = z.boolean();

export type ResultSchemaT = z.infer<typeof ResultSchema>;

export const deleteFormation = async (
  client: ApiClient,
  formationId: string
): Promise<ResultSchemaT> => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    throw new Error(t`Vous devez être connecté.`);
  }

  const validFormation = ParamsSchema.parse({ id: formationId });

  const userId = session.user.id;

  try {
    await client
      .from('quark_formations')
      .delete()
      .eq('id', validFormation.id)
      .eq('user_id', userId)
      .throwOnError();
  } catch (error) {
    throw error;
  }
  await client
    .from('quark_formations_designations')
    .delete()
    .eq('formation_id', validFormation.id)
    .throwOnError();

  return ResultSchema.parse(true);
};
